import React from 'react';

import { Apollo } from 'src/gql/generated';
import type { UserSubset } from 'src/types';

import type { UserOption } from '../../ai/reminder-automation/UserAutocomplete';
import { UserAutocomplete } from '../../ai/reminder-automation/UserAutocomplete';

interface ReminderWithAssignees extends Pick<Apollo.Reminder, 'id' | '__typename'> {
  assignees: UserSubset[];
}

interface ReminderAssigneesProps {
  reminder: ReminderWithAssignees;
}

export function ReminderAssignees({ reminder }: ReminderAssigneesProps) {
  const [updateReminder] = Apollo.useUpdateReminderMutation();

  const value: UserOption[] = reminder.assignees.map(a => ({
    __typename: a.__typename,
    avatarColor: a.avatarColor,
    displayName: a.displayName,
    id: a.id,
  }));

  return (
    <UserAutocomplete
      placeholder="Select assignees..."
      value={value}
      onChange={async users => {
        await updateReminder({
          variables: {
            input: {
              assigneeIds: users.map(u => u.id),
              reminderId: reminder.id,
            },
          },
        });
      }}
    />
  );
}
